import { render, staticRenderFns } from "./basicProperty.vue?vue&type=template&id=4e2aead4&scoped=true&"
import script from "./basicProperty.vue?vue&type=script&lang=js&"
export * from "./basicProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2aead4",
  null
  
)

export default component.exports